// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo-module_Logo_31jW8"};